export default function ArrowUpSortPopoverIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_948_82899"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
        <rect
          x="0.5"
          y="0.5"
          width="11"
          height="11"
          stroke="black"
          strokeOpacity="0.2"
        />
      </mask>
      <g mask="url(#mask0_948_82899)">
        <mask id="path-3-inside-1_948_82899" fill="white">
          <path d="M5.5 10V3.9125L2.7 6.7125L2 6L6 2L10 6L9.3 6.7125L6.5 3.9125V10H5.5Z" />
        </mask>
        <path
          d="M5.5 10V3.9125L2.7 6.7125L2 6L6 2L10 6L9.3 6.7125L6.5 3.9125V10H5.5Z"
          fill="#1C1B1F"
        />
        <path
          d="M5.5 10H4.5V11H5.5V10ZM5.5 3.9125H6.5V1.49829L4.79289 3.20539L5.5 3.9125ZM2.7 6.7125L1.98666 7.41332L2.69371 8.133L3.40711 7.41961L2.7 6.7125ZM2 6L1.29289 5.29289L0.592016 5.99377L1.28666 6.70082L2 6ZM6 2L6.70711 1.29289L6 0.585786L5.29289 1.29289L6 2ZM10 6L10.7133 6.70082L11.408 5.99377L10.7071 5.29289L10 6ZM9.3 6.7125L8.59289 7.41961L9.30629 8.133L10.0133 7.41332L9.3 6.7125ZM6.5 3.9125L7.20711 3.20539L5.5 1.49829V3.9125H6.5ZM6.5 10V11H7.5V10H6.5ZM6.5 10V3.9125H4.5V10H6.5ZM4.79289 3.20539L1.99289 6.00539L3.40711 7.41961L6.20711 4.61961L4.79289 3.20539ZM3.41334 6.01168L2.71334 5.29918L1.28666 6.70082L1.98666 7.41332L3.41334 6.01168ZM2.70711 6.70711L6.70711 2.70711L5.29289 1.29289L1.29289 5.29289L2.70711 6.70711ZM5.29289 2.70711L9.29289 6.70711L10.7071 5.29289L6.70711 1.29289L5.29289 2.70711ZM9.28666 5.29918L8.58666 6.01168L10.0133 7.41332L10.7133 6.70082L9.28666 5.29918ZM10.0071 6.00539L7.20711 3.20539L5.79289 4.61961L8.59289 7.41961L10.0071 6.00539ZM5.5 3.9125V10H7.5V3.9125H5.5ZM6.5 9H5.5V11H6.5V9Z"
          fill="black"
          fillOpacity="0.2"
          mask="url(#path-3-inside-1_948_82899)"
        />
      </g>
    </svg>
  );
}
